module.exports = new __parcel__URL__("GT-Pantheon_animation-fig-6-493_8-002.2b13e62f.json").toString();